/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reorder': {
    width: 16,
    height: 12,
    viewBox: '0 0 16 12',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 .5A.5.5 0 01.5 0h7.941a.5.5 0 010 1H.5A.5.5 0 010 .5zm0 5.294a.5.5 0 01.5-.5h6.176a.5.5 0 110 1H.5a.5.5 0 01-.5-.5zm.5 4.794a.5.5 0 100 1h6.176a.5.5 0 000-1H.5zm9.352-2.5a.5.5 0 01.708 0l1.793 1.794V.5a.5.5 0 011 0v9.381l1.794-1.793a.5.5 0 11.707.707l-2.64 2.639a.502.502 0 01-.714.008L9.852 8.795a.5.5 0 010-.707z" _fill="#3E424C"/>'
  }
})
